<template>
  <div class="schedulingplanapproval">
    <el-row>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in tabsList" :label="item.name" :name="item.nursingGroupId" :key="index">
          <span slot="label">{{ item.name }}<el-badge :is-dot="Boolean(item.nums)" /></span>
          <el-row class="row-title">
            <el-col :span="2" align="right" style="margin-right: 5px"><kt-button label="上一月" type="primary"
                @click="handlePrevWeek" /></el-col>
            <el-col :span="4">
              <el-date-picker style="width: 180px" :editable="false" :clearable="false" v-model="dateValue" type="month"
                @change="changeData" value-format="yyyy-MM" format="yyyy-MM"
                :placeholder="thisWeekArrangePlan.optionDate">
              </el-date-picker>
            </el-col>
            <el-col :span="2"><kt-button label="下一月" type="primary" @click="handleNextWeek" /></el-col>
          </el-row>
          <el-row style="
              height: 54px;
              line-height: 54px;
              background: #f9f7fa;
              border: 1px #f1eff2 solid;
              margin-top: 20px;
            ">
            <el-col :span="4" style="font-size: 18px">
              <img src="@/assets/beadhouse/juxing.png" alt="" style="vertical-align: middle; margin: 0 10px" />
              <span>{{ thisWeekArrangePlan.schedulingPlan }}</span>
            </el-col>
            <el-col :span="6" :offset="14" align="right"><span style="margin-right: 15px">{{ monthStr }}</span>
            </el-col>
          </el-row>
          <el-row style="width: 100%;overflow-x: auto;">
            <table class="tables" v-if="schemeList.length > 0">
              <tr>
                <th class="tableth">
                  <p>日期</p>
                </th>
                <th class="tableth" v-for="(item, index) in daySelect" :key="index">
                  <p>{{ item.day }}</p>
                </th>
              </tr>
              <!-- for 班次 -->
              <tr>
                <th class="tableth">{{ schemeCiName }}</th>
                <th class="tableth" v-for="(item, index) in schemeList" :key="index">
                  {{ item.name }}
                </th>
              </tr>
              <tr>
                <th class="tableth">{{ thisWeekArrangePlan.operation }}</th>
                <th class="tableth" :colspan="4">
                  <!-- :if="shemeId!=''" -->
                  <div v-if="shemeId != '' && statusCode == 0" :class="{
                    statusImgShowA: isTrueA,
                    statusImgShowB: isTrueB,
                  }">
                    <img src="@/assets/beadhouse/pbbutongguo.png" alt="" class="status-img-x" @click="handlePass" />
                    <img src="@/assets/beadhouse/pbtongguo.png" alt="" class="status-img-x" @click="handleNoPass" />
                  </div>
                </th>
                <th class="tableth">{{ thisWeekArrangePlan.status }}</th>

                <th class="tableth" :colspan="daySelect.length - 5">
                  {{ status }}
                </th>
              </tr>
            </table>

          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <!-- 审批不通过的dialog模态框-->
    <el-dialog :title="thisWeekArrangePlan.confirmationInformation" width="30%" :visible.sync="dialogVisibleNoPass"
      :close-on-click-modal="false" @close="closeDialogVisibleNoPass">
      <el-form :model="noPassForm" label-width="100px" :rules="noPassFormRules" ref="noPassForm" label-position="right">
        <el-form-item label="" prop="nursingItem">
          <span class="noPassTitle">{{ thisWeekArrangePlan.noPassTitle }}</span>
        </el-form-item>
        <el-form-item :label="thisWeekArrangePlan.reason" prop="reason">
          <el-input v-model.trim="noPassForm.reason" type="textarea" :rows="5" auto-complete="off"
            style="width: 80%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisibleNoPass = false">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitFormNoPass"
          :loading="noPassFormLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
import util from "@/utils/util.js";
export default {
  name: "SchedulingPlanApproval",
  components: { KtTable, KtButton },
  data() {
    return {
      weeklyDays: [],
      nursingGroupId: "", //护工组id
      thisWeekArrangePlan: {
        which: "第",
        week: "周",
        to: "至",
        Monday: "周一",
        Tuesday: "周二",
        Wednesday: "周三",
        Thursday: "周四",
        Friday: "周五",
        Saturday: "周六",
        Sunday: "周日",
        editorThisWeekSchedule: "编辑本周排班",
        addNextWeekSchedule: "添加下周排班",
        viewAllPlans: "查看全部计划",
        schedulingScheme: "排班方案",
        optionDate: "选择日期",
        thisWeekSchedule: "本周排班计划",
        nextWeekSchedule: "下周排班计划",
        thisMonSchedule: "本月排班计划",
        nextMonSchedule: "下月排班计划",

        allSchedule: "所有排班计划",
        loading: "拼命加载中...",
        status: "状态",
        approvalPending: "待审批",
        add: "添加",
        careManagement: "护工列表",
        schedulingPlan: "排班计划",
        operation: "操作",
        confirmationInformation: "信息确认",
        noPassTitle: "你确定不通过排班计划吗?",
        reason: "原因",
        notEmpty: "不能为空",
        messageLen: "长度在 1到 50 的字符"
      }, //引入 lang 里面的字符串资源,
      dateValue: util.formatDate.format(new Date(), "yyyy-MM-dd"),
      activeName: "",
      labelList: [],
      schemeList: [], // 排班计划数据
      isAllChecked: false,
      week: "", //第几周
      whichWeekTo: "", //某某年月日到某某年月日
      Monday: "",
      Tuesday: "",
      Wednesday: "",
      Thursday: "",
      statusCode: 0,
      Friday: "",
      Saturday: "",
      Sunday: "",
      tabsList: [],
      daySelect: [],
      monthStr: "",
      shemeId: "",
      schemeCiName: "全天",
      currentScheme: {}, //当前排班计划;
      thisWeekArrangePlanList: [],
      statusImgShow: true, //审批通过和不通过图标的显示和隐藏
      status: "", //审批状态
      reason: "", //原因
      isTrueA: true,
      isTrueB: false,
      //审批不通过的dialog配置
      dialogVisibleNoPass: false, //dialog显示 true 或   隐藏 false
      noPassForm: {}, //审批不通过的数据源
      noPassFormRules: {
        reason: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
          {
            min: 0,
            max: 50,
            message: "长度在 1到 50 的字符",
          },
        ],
      },
      noPassFormLoading: false, //审批不通过提交按钮的loading
      size: "medium", //按钮的尺寸
      roleCodeFlag: true, //by guo 2019-12-05-11:11添加  判断是否为护工的角色  为护工就为false  否则就为true
    };
  },
  methods: {
    /* 不通过审批清空数据 */
    closeDialogVisibleNoPass() {
      this.$refs["noPassForm"].resetFields();
    },
    /* 
            选项卡点击事件
        */
    handleClick(tab, event) {
      console.log(tab, event);
      console.log(tab.name);
      this.nursingGroupId = tab.name;
      this.queryScheduleList();
    },

    /* 
            上一周
        */
    handlePrevWeek() {
      // 获得当前日期
      var yearMonth = this.monthStr;
      var year = yearMonth.split("-")[0];
      var month = yearMonth.split("-")[1];
      month = parseInt(month, 10);
      year = parseInt(year);
      if (month == 1) {
        month = 12;
        year = year - 1;
      } else {
        month = month - 1;
      }
      this.dateValue = year + "-" + month;
      this.nextWeekPlanShow = false;
      this.thisWeekPlanShow = false;
      this.initDay(year, month); //查询天数
      //2.置为edit状态
      this.isEditStatus = false;
      //3.显示底部按钮
      // this.saveAndBackShow = true;
      this.buttonShow = false;
      // this.planShow = true;
      // 启用排班计划编辑
      this.planDisabled = false; // 如果本月没有排班计划通过审批的话
      // this.dateShow = true;
      this.queryScheduleList();
    },

    /* 
            下一周
        */
    handleNextWeek() {
      var yearMonth = this.monthStr;
      var year = yearMonth.split("-")[0];
      var month = yearMonth.split("-")[1];
      year = parseInt(year);
      month = parseInt(month, 10);
      if (month == 12) {
        month = 1;
        year = year + 1;
      } else {
        month = month + 1;
      }
      this.dateValue = year + "-" + month;
      this.nextWeekPlanShow = false;
      this.thisWeekPlanShow = false;
      this.initDay(year, month); //查询天数
      //2.置为edit状态
      this.isEditStatus = false;
      //3.显示底部按钮
      // this.saveAndBackShow = true;
      this.buttonShow = false;
      // this.planShow = true;
      // 启用排班计划编辑
      this.planDisabled = false; // 如果本月没有排班计划通过审批的话
      // this.dateShow = true;
      this.queryScheduleList();
    },

    /* 
            点击时间获取数据  by xiang
        */
    changeData(val) {
      this.labelList = []; //清空数据
      console.log(val);
      var year = val.split("-")[0];
      var month = val.split("-")[1];
      this.nextWeekPlanShow = false;
      this.thisWeekPlanShow = false;
      this.initDay(year, month); //查询天数
      //2.置为edit状态
      this.isEditStatus = false;
      //3.显示底部按钮
      // this.saveAndBackShow = true;
      this.buttonShow = false;
      // this.planShow = true;
      // 启用排班计划编辑
      this.planDisabled = false; // 如果本月没有排班计划通过审批的话
      // this.dateShow = true;
      this.queryScheduleList();
    },

    /* ************* 排班计划的时间处理 ********** */

    /* 
            获取某年某月某天是第几周   第一天为周一
        */
    getWeekNumber(data) {
      var today = new Date(data);
      var firstDay = new Date(today.getFullYear(), 0, 1);
      var dayOfWeek = firstDay.getDay();
      var spendDay = 1;
      if (dayOfWeek != 0) {
        spendDay = 7 - dayOfWeek + 1;
      }
      firstDay = new Date(today.getFullYear(), 0, 1 + spendDay);
      var d = Math.ceil((today.valueOf() - firstDay.valueOf()) / 86400000);
      var result = Math.ceil(d / 7);
      console.log(result, "周几周几周几周几周几周几");
      return result + 1;
    },

    /*  
            获取本周 周一是1,周日是7
        */
    getWeekDay(val) {
      var new_Date = new Date(val);
      var timesStamp = new_Date.getTime();
      var currenDay = new_Date.getDay();
      var dates = [];
      for (var i = 0; i < 7; i++) {
        dates.push(
          new Date(
            timesStamp + 24 * 60 * 60 * 1000 * (i - ((currenDay + 6) % 7))
          )
            .toLocaleDateString()
            .replace(/[年月]/g, "-")
            .replace(/[日上下午]/g, "")
        );
      }
      console.log(dates);
      this.weeklyDays = dates;
    },

    /* 
            获取所有的护工组
        */
    selectShowAll() {
      //请求数据之前先把数据清空
      this.tabsList = [];
      this.$postJson("omc/group/selectShowAll").then((res) => {
        console.log(res);
        if (res.result.length > 0) {
          res.result.forEach((item, index) => {
            if (index == 0) {
              //获取默认初始值
              this.activeName = String(item.id);
              this.nursingGroupId = String(item.id);
            }
            var tabsObj = {};
            tabsObj.nursingGroupId = String(item.id);
            tabsObj.name = item.name;
            tabsObj.nums = item.nums;
            this.tabsList.push(tabsObj);
          });
        }
        console.log(this.tabsList);
      });
    },

    getDayFromMon(year, month) {
      month = parseInt(month, 10);
      var temp = new Date(year, month, 0);
      return temp.getDate();
    },
    /* 
            查询排班计划
        */
    queryScheduleList() {
      this.schemeList = [];
      this.shemeId = "";
      this.$postJson("omc/schedule/getSchedulMonth", {
        month: this.monthStr,
        nursingGroupId: this.nursingGroupId,

      }).then((res) => {
        if (res.code == 200 && res.result.length != 0) {
          //有计划了;
          this.currentScheme = {
            planId: res.result[0].planId,
            shiftsId: res.result[0].omcShifts.id,
          };
          this.shemeId = res.result[0].id;
          this.plan = res.result[0].planId;
          this.statusCode = res.result[0].status;
          switch (res.result[0].status) {
            case 0:
              this.status = "未审批";
              break;
            case 1:
              this.status =
                " 审批不通过" + "          原因：" + res.result[0].reason;
              break;
            default:
              this.status = "审批通过";
          }
          this.schemeCiName = "全天";
          if (res.result[0].omcShifts != null) {
            this.schemeCiName = res.result[0].omcShifts.name;
          }
          this.schemeList.push({
            name: res.result[0].firstDayRealName,
            user: res.result[0].firstDayUserId.split("-"),
            idStr: res.result[0].firstDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].secondDayRealName,
            user: res.result[0].secondDayUserId.split("-"),
            idStr: res.result[0].secondDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].thirdDayRealName,
            user: res.result[0].thirdDayUserId.split("-"),
            idStr: res.result[0].thirdDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].fourthDayRealName,
            user: res.result[0].fourthDayUserId.split("-"),
            idStr: res.result[0].fourthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].fifthDayRealName,
            user: res.result[0].fifthDayUserId.split("-"),
            idStr: res.result[0].fifthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].sixthDayRealName,
            user: res.result[0].sixthDayUserId.split("-"),
            idStr: res.result[0].sixthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].seventhDayRealName,
            user: res.result[0].seventhDayUserId.split("-"),
            idStr: res.result[0].seventhDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].eighthDayRealName,
            user: res.result[0].eighthDayUserId.split("-"),
            idStr: res.result[0].eighthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].ninthDayRealName,
            user: res.result[0].ninthDayUserId.split("-"),
            idStr: res.result[0].ninthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].tenthDayRealName,
            user: res.result[0].tenthDayUserId.split("-"),
            idStr: res.result[0].tenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].elevenDayRealName,
            user: res.result[0].elevenDayUserId.split("-"),
            idStr: res.result[0].elevenDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twelveDayRealName,
            user: res.result[0].twelveDayUserId.split("-"),
            idStr: res.result[0].twelveDayUserId,
          });

          this.schemeList.push({
            name: res.result[0].thirteenthDayRealName,
            user: res.result[0].thirteenthDayUserId.split("-"),
            idStr: res.result[0].thirteenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].fourteenthDayRealName,
            user: res.result[0].fourteenthDayUserId.split("-"),
            idStr: res.result[0].fourteenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].fifteenthDayRealName,
            user: res.result[0].fifteenthDayUserId.split("-"),
            idStr: res.result[0].fifteenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].sixteenthDayRealName,
            user: res.result[0].sixteenthDayUserId.split("-"),
            idStr: res.result[0].sixteenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].seventeenthDayRealName,
            user: res.result[0].seventeenthDayUserId.split("-"),
            idStr: res.result[0].seventeenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].eighteenthDayRealName,
            user: res.result[0].eighteenthDayUserId.split("-"),
            idStr: res.result[0].eighteenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].ninteenthDayRealName,
            user: res.result[0].ninteenthDayUserId.split("-"),
            idStr: res.result[0].ninteenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentythDayRealName,
            user: res.result[0].twentythDayUserId.split("-"),
            idStr: res.result[0].twentythDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentyFirstDayRealName,
            user: res.result[0].twentyFirstDayUserId.split("-"),
            idStr: res.result[0].twentyFirstDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentySecondDayRealName,
            user: res.result[0].twentySecondDayUserId.split("-"),
            idStr: res.result[0].twentySecondDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentyThirdDayRealName,
            user: res.result[0].twentyThirdDayUserId.split("-"),
            idStr: res.result[0].twentyThirdDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentyFourthDayRealName,
            user: res.result[0].twentyFourthDayUserId.split("-"),
            idStr: res.result[0].twentyFourthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentyFifthDayRealName,
            user: res.result[0].twentyFifthDayUserId.split("-"),
            idStr: res.result[0].twentyFifthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentySixthDayRealName,
            user: res.result[0].twentySixthDayUserId.split("-"),
            idStr: res.result[0].twentySixthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentySeventhDayRealName,
            user: res.result[0].twentySeventhDayUserId.split("-"),
            idStr: res.result[0].twentySeventhDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentyEighthDayRealName,
            user: res.result[0].twentyEighthDayUserId.split("-"),
            idStr: res.result[0].twentyEighthDayUserId,
          });
          if (this.daySelect.length > 28) {
            this.schemeList.push({
              name: res.result[0].twentyNinthDayRealName,
              user: res.result[0].twentyNinthDayUserId.split("-"),
              idStr: res.result[0].twentyNinthDayUserId,
            });
          }
          if (this.daySelect.length > 29) {
            this.schemeList.push({
              name: res.result[0].thirtiethDayRealName,
              user: res.result[0].thirtiethDayUserId.split("-"),
              idStr: res.result[0].thirtiethDayUserId,
            });
          }
          if (this.daySelect.length > 30) {
            this.schemeList.push({
              name: res.result[0].thirtyFirstDayRealName,
              user: res.result[0].thirtyFirstDayUserId.split("-"),
              idStr: res.result[0].thirtyFirstDayUserId,
            });
          }
          console.log(this.schemeList);
        } else {
          this.currentScheme = {
            planId: "",
            shiftsId: "",
          };
          this.plan = "";
          this.status = "";
          this.schemeCiName = "全天";
          // this.daySelect.forEach((item) => {
          //   this.schemeList.push({
          //     name: "",
          //     user: [],
          //     idStr: "",
          //   });
          // });
        }
        console.log(this.schemeList, "this.schemeList");
      });
    },

    /* 
            排班审批通过confirm
        */
    handlePass() {
      this.$confirm("你确定通过排班计划吗?", "信息确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          let params = {};
          params.nursingGroupId = this.nursingGroupId;
          params.id = this.shemeId;
          params.status = 2; //0-未审批1-审批未通过2-审批通过
          params.reason = this.noPassForm.reason; //审批原因
          params.month = this.monthStr,
            console.log(params);
          this.noPassFormLoading = true;
          this.$postJson("omc/schedule/approvalScheduleMonth", params).then(
            (res) => {
              console.log(res);
              this.dialogVisibleNoPass = false;
              this.noPassFormLoading = false;
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
              } else {
                this.$message({ message: res.message, type: "error" });
              }
              this.selectShowAll();
              this.queryScheduleList();
            }
          );
        })
        .catch(() => { });
    },

    /* 
            排班审批不通过弹出dialog
        */
    handleNoPass() {
      this.dialogVisibleNoPass = true;
      this.noPassForm = {
        reason: "",
      };
    },
    initDay(year, month) {
      // 1.获取当前月
      var dayNum = this.getDayFromMon(year, month);
      if (month < 10) {
        this.monthStr = year + "-0" + month;
      } else {
        this.monthStr = year + "-" + month;
      }
      var dayCheckList = [];
      for (var i = 1; i < dayNum + 1; i++) {
        dayCheckList.push({
          day: "" + i,
          check: false,
        });
      }
      this.daySelect = dayCheckList;
    },
    /* 
            审批不通过提交数据
        */
    submitFormNoPass() {
      this.$refs.noPassForm.validate((valid) => {
        if (valid) {
          let params = {};
          params.id = this.shemeId;
          params.nursingGroupId = this.nursingGroupId;
          params.status = 1; //0-未审批1-审批未通过2-审批通过
          params.reason = this.noPassForm.reason; //审批原因
          params.month = this.monthStr,
            console.log(params);
          this.noPassFormLoading = true;
          this.$postJson("omc/schedule/approvalScheduleMonth", params).then(
            (res) => {
              console.log(res);
              this.dialogVisibleNoPass = false;
              this.noPassFormLoading = false;
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
              } else {
                this.$message({ message: res.message, type: "error" });
              }
              this.queryScheduleList();
            }
          );
        }
      });
    },
  },
  created() {
    //by guo 2019-12-05-11:15 添加
    let roleCode = sessionStorage.getItem("roleCode");
    if (roleCode == "nursing") {
      this.roleCodeFlag = false;
    }
  },
  mounted() {
    var now = new Date();
    this.initDay(now.getFullYear(), now.getMonth() + 1); //查询本月天数
    if (this.roleCodeFlag == true) {
      //by guo 2019-12-05-11:15 添加
      this.selectShowAll();
      //延迟加载，否则this.nursingGroupId无法取到
      this.$nextTick(() => {
        setTimeout(() => {
          this.queryScheduleList();
        }, 500);
      });
      //by guo 2019-11-14-19:15添加  监听刷新表格的数据
      //监听 待办事项页面的
      this.$bus.$on("refreshSchedulingApproval", () => {
        console.log("待办事项页面传来的");
        this.queryScheduleList(); //刷新列表的数据
      });
    } else {
      //by guo 2019-12-05-11:15 添加
      this.$message({
        message: "该角色为护工,不能进行排班审批",
        type: "error",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.tables {
  width: 100%;
  border-collapse: collapse;
}

.tableth {
  width: 3%;
  height: 40px;
  min-width: 50px;
  background: white;
  border: 1px #9f9e9e solid;
}

.tables ::v-deep .el-checkbox__label {
  padding-left: 3px;
  font-size: 14px;
  text-align: center;
}

.schedulingplanapproval {
  width: 100%;
  height: 100%;
  background: #fefefe;

  .ml10 {
    margin-left: 10px;
    padding-top: 5px;
  }

  //by guo 2019-10-30-17:17 修改  给每一行每一列的给一个最小高度  让其可以高度自适应
  .minHeight {
    min-height: 40px;
    line-height: 20px;
  }

  .status {
    width: 100%;
    height: 65px;
    border: 1px solid #ebeef5;
    border-top: none;
    box-sizing: border-box;

    .status-operation {
      width: 204px;
      height: 65px;
      line-height: 65px;
      text-align: center;
      border-right: 1px solid #ebeef5;
      float: left;
    }

    .statusImgShowA {
      width: 492px;
      height: 65px;
      line-height: 65px;
      text-align: center;
      border-right: 1px solid #ebeef5;
      float: left;
      opacity: 1;

      .status-img-x {
        vertical-align: middle;
        margin: 0 40px;
        cursor: pointer;
      }
    }

    .statusImgShowB {
      width: 492px;
      height: 65px;
      line-height: 65px;
      text-align: center;
      border-right: 1px solid #ebeef5;
      float: left;
      opacity: 0;
    }

    .status-statustext {
      width: 165px;
      height: 65px;
      line-height: 65px;
      text-align: center;
      border-left: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
      float: left;
    }

    .status-status {
      min-width: 97%;
      height: 65px;
      line-height: 65px;
      text-align: center;
      float: left;
    }
  }

  .noPassTitle {
    text-align: center;
    color: #002;
    font-size: 18px;
  }
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}

.clearfix {
  *zoom: 1;
}

//去除表格hover高亮
::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #ffffff !important;
}

::v-deep .el-table .el-table__body td {
  padding: 0px !important;
}

::v-deep .el-table .cell {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

::v-deep .el-dialog .el-dialog__body {
  padding: 20px 20px 10px 20px !important;
}
</style>
